import DealershipForm from "./components/dealershipForm";
import { Loading } from "../../../../utils/loading";

import { Dealership } from "../../../../models/dealership";
import { Asset } from "../../../../models/asset";

import AssetsAndDriversForm from "./components/assetsAndDriversForm";
import DateAndConsultantForm from "./components/dateAndConsultantForm";
import AppointmentSummary from "./components/appointmentSummary";

import { IAssetAndDriverForm, IDateAndConsultantForm, useSchedulingForm } from "../../../../hooks/useSchedulingForm";

import "./styles.scss";

const Appointment = (props: any) => {
  const {
    loading,
    step, setStep,
    drivers,
    appointmentForm, setAppointmentForm,
    appointmentId,
  } = useSchedulingForm();

  return (
    <div className="appointment h-full">
      <div className="h-full w-full flex justify-center">
        {loading ? (
          <Loading label="Carregando dados..." />
        ) : (
          <div className="w-full h-full bg-white dark:bg-neutral-900">
            <div className="stepsSchedule h-full">
              {step === 1 && (
                <AssetsAndDriversForm
                  setStep={setStep}
                  drivers={drivers}
                  form={appointmentForm?.assetsAndDrivers}
                  setAppointmentForm={(
                    assetsAndDriversForm: IAssetAndDriverForm
                  ) =>
                    setAppointmentForm({
                      ...appointmentForm,
                      assetsAndDrivers: assetsAndDriversForm,
                    })
                  }
                />
              )}

              {step === 2 && (
                <DealershipForm
                  asset={appointmentForm?.assetsAndDrivers?.asset}
                  setAsset={(asset: Asset) => {
                    setAppointmentForm({
                      ...appointmentForm,
                      assetsAndDrivers: {
                        ...appointmentForm?.assetsAndDrivers,
                        asset,
                      },
                    });
                  }}
                  dealership={appointmentForm?.dealership}
                  setDealership={(dealership: Dealership) =>
                    setAppointmentForm({ ...appointmentForm, dealership })
                  }
                  setStep={setStep}
                />
              )}

              {step === 3 && (
                <DateAndConsultantForm
                  dealership={appointmentForm?.dealership}
                  setStep={setStep}
                  form={appointmentForm?.dateAndConsultant}
                  isReschedule={!!appointmentId}
                  setAppointmentForm={(
                    dateAndConsultantForm: IDateAndConsultantForm
                  ) =>
                    setAppointmentForm({
                      ...appointmentForm,
                      dateAndConsultant: dateAndConsultantForm,
                    })
                  }
                />
              )}

              {step === 4 && (
                <AppointmentSummary
                  appointmentForm={appointmentForm}
                  setStep={setStep}
                  schedulingId={appointmentId}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Appointment